// hooks/useHandleContainerClicks.js - UPDATED FOR FULLFEEDPAGE ROUTING
import { useNavigate } from 'react-router-dom';

// Updated handlers to match FullFeedPage URL structure
export const useHandleContainerClickRecents = () => {
  return (collectionName, tableName) => {
    // Navigate to FullFeedPage with proper path parameters
    window.location.href = `/feed/united_states_of_america/${tableName}`;
  };
};

export const useHandleContainerClickRecentsCanada = () => {
  return (collectionName, tableName) => {
    // Navigate to FullFeedPage with proper path parameters  
    window.location.href = `/feed/canada/${tableName}`;
  };
};

export const useHandleContainerClickRecentsMexico = () => {
  return (collectionName, tableName) => {
    // Navigate to FullFeedPage with proper path parameters
    window.location.href = `/feed/mexico/${tableName}`;
  };
};

// Optional: You can also add a UK handler if needed
export const useHandleContainerClickRecentsUK = () => {
  return (collectionName, tableName) => {
    // Navigate to FullFeedPage with proper path parameters
    window.location.href = `/feed/united_kingdom/${tableName}`;
  };
};



export const useHandleContainerClickRecentsWithNavigate = () => {
  const navigate = useNavigate();
  
  return (collectionName, tableName) => {
    navigate(`/feed/united_states_of_america/${tableName}`);
  };
};

export const useHandleContainerClickRecentsCanadaWithNavigate = () => {
  const navigate = useNavigate();
  
  return (collectionName, tableName) => {
    navigate(`/feed/canada/${tableName}`);
  };
};

export const useHandleContainerClickRecentsMexicoWithNavigate = () => {
  const navigate = useNavigate();
  
  return (collectionName, tableName) => {
    navigate(`/feed/mexico/${tableName}`);
  };
};

export const useHandleContainerClickRecentsUKWithNavigate = () => {
  const navigate = useNavigate();
  
  return (collectionName, tableName) => {
    navigate(`/feed/united_kingdom/${tableName}`);
  };
};